import { onPushFullScreen } from 'shared/map/ui/components/control-buttons/components/fullscreen/lib';
import { useCallback, useRef } from 'react';
export const useFullscreen = () => {
    const ref = useRef(null);
    const onClickFullScreen = useCallback(() => onPushFullScreen(ref.current), []);
    return [ref, onClickFullScreen];
};
